/**
 * Institution (main school) login vs staff/teacher login.
 * Keep aligned with session heuristics in menu.js.
 */

export function isMainSchoolAccount(account) {
  const adminObj = account && typeof account === 'object' ? account : {};
  const hasSchoolScope = Boolean(adminObj.schoolname);
  if (!hasSchoolScope) return false;

  const institutionSchoolCredential =
    adminObj.primarypassword != null &&
    String(adminObj.primarypassword || '').trim() !== '' &&
    !String(adminObj.password || '').trim();

  const explicitSchoolJwtShape =
    adminObj.role === 'school' || adminObj.type === 'school';

  const noStaffPositionField = !String(adminObj.positiondescription || '').trim();

  const looksLikeTeacherRecord =
    Boolean(String(adminObj.password || '').trim()) ||
    (adminObj.ID != null && String(adminObj.ID || '').trim() !== '') ||
    Boolean(String(adminObj.lastname || '').trim()) ||
    Boolean(String(adminObj.othernames || '').trim());

  return (
    explicitSchoolJwtShape ||
    institutionSchoolCredential ||
    noStaffPositionField ||
    !looksLikeTeacherRecord
  );
}

export function mainSchoolAccountDisplayName(account) {
  if (!account || typeof account !== 'object') return 'Main school account';
  if (account.schoolname) return String(account.schoolname).trim();
  if (account.lastname && account.othernames) {
    return `${account.lastname} ${account.othernames}`.trim();
  }
  return 'Main school account';
}

/** Normalize Mongo _id from Redux / localStorage (string, id, or extended JSON). */
export function resolveMongoId(record) {
  if (record == null) return '';
  if (typeof record === 'string' || typeof record === 'number') {
    return String(record).trim();
  }
  if (typeof record !== 'object') return '';
  const raw = record._id != null ? record._id : record.id;
  if (raw == null) return '';
  if (typeof raw === 'object' && raw.$oid) return String(raw.$oid).trim();
  return String(raw).trim();
}

export function resolveSchoolAccountEmail(account) {
  if (!account || typeof account !== 'object') return '';
  return String(account.email ?? '').trim().toLowerCase();
}
